import React, { useContext, useMemo } from "react";
import style from "./index.module.scss";
import DetailLayout from "../components/DetailLayout";
import CourseHeader from "../components/CourseHeader";
import Buttons from "./components/Buttons";
import StudentsTable from "./components/StudentsTable";
import { Route, Switch, useParams } from "react-router-dom";
import moment from "moment";
import { useSearchParam } from "react-use";
import { Provider, useAtom } from "jotai";
import ExerciseReview from "../ExerciseReview";
import { CourseContext } from "../Store";
import {
    exerciseIdAtom,
    filterAndSortMarkList,
    markListAtom,
    statusFilterAtom
} from "service/stores/Exercise/Students";
import { useAtomValue } from "jotai";
import ViewPublishLog from "../Exercise/components/ViewPublishLog";

function ExerciseStudents() {
    const exerciseId = useAtomValue(exerciseIdAtom);
    const [filter, setFilter] = useAtom(statusFilterAtom);
    const data = useAtomValue(markListAtom);

    // 筛选数据
    const markList = useAtomValue(filterAndSortMarkList);

    const info = useMemo(
        () => (
            <div>
                <ViewPublishLog id={Number(exerciseId)} />
                活动时长 {data.exercise.validityTime} ｜ 开始时间
                {data.exercise.startTime
                    ? moment(data.exercise.startTime).format("MM-DD HH:mm")
                    : "--"}{" "}
                结束时间
                {data.exercise.endTime
                    ? moment(data.exercise.endTime).format("MM-DD HH:mm")
                    : "--"}
            </div>
        ),
        [data]
    );

    return (
        <DetailLayout breadcrumb="练习详情">
            {data && (
                <CourseHeader
                    title={data.exercise.description}
                    info={info}
                    extra={
                        <span className={style.percent}>
                            参与率{data.joinPercent}
                        </span>
                    }
                />
            )}

            {data && (
                <Buttons
                    status={filter}
                    onChange={setFilter}
                    exerciseAllCount={data.studentNo}
                    noJudgeCount={data.unMarkNo}
                    judgeCount={data.markNo}
                    noJoinInExerciseCount={data.unJoinNo}
                    exerciseId={exerciseId}
                    data={markList}
                />
            )}

            <StudentsTable data={markList} exerciseId={exerciseId} />
        </DetailLayout>
    );
}

export default function ExerciseStudentsRoot() {
    const { basename } = useContext(CourseContext);
    const { exerciseId } = useParams<{ exerciseId: string }>();
    const status = useSearchParam("status") || "all"; // 默认过滤状态
    const exerciseBaseName = `${basename}/exercise/students/${exerciseId}`;

    return (
        <Provider
            initialValues={
                [
                    [exerciseIdAtom, exerciseId],
                    [statusFilterAtom, status]
                ] as any
            }>
            <Switch>
                <Route
                    path={`${exerciseBaseName}/review/:studentNo`}
                    component={ExerciseReview}
                />
                <Route component={ExerciseStudents} />
            </Switch>
        </Provider>
    );
}
